import { ArrowUpCircle, Edit, Trash2 } from "lucide-react";
import { RecordFilters } from "..";

const OutwardSection = ({ ctx }) => {
  const {
    exportOutward,
    filteredOutward,
    getEquipmentLabel,
    getMaterialName,
    handleBulkDeleteOutward,
    handleDeleteOutward,
    handleEditOutward,
    isMasterAdmin,
    materials,
    outwardFilters,
    outwardRecords,
    outwardSummary,
    selectedOutwardIds,
    setOutwardFilters,
    setSelectedOutwardIds,
    toggleSelectAllOutward
  } = ctx;
  return (
    <>
        <div>
          {/* Bulk Delete Button */}
          {isMasterAdmin && selectedOutwardIds.length > 0 && (
            <div className="mb-4 flex items-center justify-between bg-error/10 border border-error/30 rounded-sm p-3">
              <span className="text-sm font-medium text-error">
                {selectedOutwardIds.length} {selectedOutwardIds.length === 1 ? 'entry' : 'entries'} selected
              </span>
              <button
                onClick={handleBulkDeleteOutward}
                className="btn-primary bg-error hover:bg-error/90 flex items-center space-x-2"
              >
                <Trash2 className="w-4 h-4" />
                <span>Delete Selected</span>
              </button>
            </div>
          )}
          
          <RecordFilters
            prefix="outward"
            filters={outwardFilters}
            setFilters={setOutwardFilters}
            records={outwardRecords}
            materials={materials}
            partyKey="issued_to"
            partyLabel="Issued To"
            summary={outwardSummary}
            onExport={exportOutward}
          />
          <div className="stat-card overflow-x-auto">
            <table className="w-full" data-testid="outward-table">
              <thead>
                <tr className="border-b-2 border-slate-300">
                  {isMasterAdmin && (
                    <th className="py-3 px-4 w-10">
                      <input
                        type="checkbox"
                        checked={filteredOutward.length > 0 && selectedOutwardIds.length === filteredOutward.length}
                        onChange={toggleSelectAllOutward}
                        className="w-4 h-4 rounded border-slate-300 text-primary focus:ring-primary"
                        title="Select All"
                      />
                    </th>
                  )}
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Issue No.</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Date</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Material</th>
                  <th className="text-right py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Quantity</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Issued To</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Machine</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Purpose</th>
                  <th className="text-left py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Remarks</th>
                  {isMasterAdmin && (
                    <th className="text-center py-3 px-4 text-xs uppercase tracking-widest text-slate-700 font-medium">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {filteredOutward.map((record) => (
                  <tr key={record.id} className={`border-b border-slate-200 hover:bg-slate-50 ${selectedOutwardIds.includes(record.id) ? 'bg-primary/5' : ''}`}>
                    {isMasterAdmin && (
                      <td className="py-3 px-4">
                        <input
                          type="checkbox"
                          checked={selectedOutwardIds.includes(record.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedOutwardIds([...selectedOutwardIds, record.id]);
                            } else {
                              setSelectedOutwardIds(selectedOutwardIds.filter(id => id !== record.id));
                            }
                          }}
                          className="w-4 h-4 rounded border-slate-300 text-primary focus:ring-primary"
                        />
                      </td>
                    )}
                    <td className="py-3 px-4 font-mono text-sm font-medium text-warning">{record.issue_number}</td>
                    <td className="py-3 px-4 font-mono text-sm">{record.date}</td>
                    <td className="py-3 px-4 text-sm font-medium">
                      {record.is_fuel_issue && "⛽ "}
                      {getMaterialName(record.material_id)}
                    </td>
                    <td className="py-3 px-4 text-right font-mono text-sm font-bold text-warning">-{record.quantity?.toFixed(2)}</td>
                    <td className="py-3 px-4 text-sm">{record.issued_to}</td>
                    <td className="py-3 px-4 text-sm text-slate-600" data-testid={`outward-machine-${record.id}`}>{getEquipmentLabel(record.equipment_id) || '-'}</td>
                    <td className="py-3 px-4 text-sm">{record.purpose}</td>
                    <td className="py-3 px-4 text-sm text-slate-500">{record.remarks || '-'}</td>
                    {isMasterAdmin && (
                      <td className="py-3 px-4 text-center">
                        <div className="flex items-center justify-center space-x-1">
                          <button
                            onClick={() => handleEditOutward(record)}
                            data-testid={`edit-outward-${record.id}`}
                            className="p-1 hover:bg-slate-200 rounded"
                            title="Edit Outward Entry"
                          >
                            <Edit className="w-4 h-4 text-primary" />
                          </button>
                          <button
                            onClick={() => handleDeleteOutward(record.id, record.issue_number)}
                            data-testid={`delete-outward-${record.id}`}
                            className="p-1 hover:bg-red-100 rounded"
                            title="Delete Outward Entry"
                          >
                            <Trash2 className="w-4 h-4 text-error" />
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredOutward.length === 0 && (
              <div className="text-center py-12 text-slate-500" data-testid="outward-empty">
                <ArrowUpCircle className="w-16 h-16 mx-auto mb-4 text-slate-400" />
                {outwardRecords.length === 0 ? "No outward records yet." : "No outward records match the filters."}
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default OutwardSection;
